module.exports = __webpack_public_path__ + "../static/img/dashboards_mini.ab1cfd85.png";